//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "QuizQuestionResultAnswerView",
  created() {},
  props: ["result"],
  data() {
    return {};
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/quiz/quiz_question_result/QuizQuestionResultAnswerView.vue